(ns storrito.editor.question-sticker
  (:require [storrito.editor.sticker-util :as sticker-util]
            [storrito.editor.poll-v2-sticker :as poll-v2-sticker]))

;; Concept:
;;
;; Creates a FabricJS object that looks like an Instagram question
;; sticker

(defn question-sticker
  "Builds the fabricjs representation of an Instagram question sticker"
  [params]
  ;; Bugfix for wrong text bounding boxes
  ;; Due to wrong calculated char width in cache, the cache needs to be cleared
  ;; Found at: https://github.com/kangax/fabric.js/issues/2612
  (js/fabric.util.clearFabricFontCache)
  (let [question-width 770
        min-panel-height 327
        answer-width 682
        answer-height 140
        text (:question params)
        ;; A sticker without colors would let the garden color functions
        ;; throw, so fall back to the defaults of the question dialog:
        background-color (or (:background-color params) "#ffffff")
        text-color (or (:text-color params) "#000000")
        shadow #js{:color "rgba(0, 0, 0, 0.5)",
                   :blur 5,
                   :offsetX 3,
                   :offsetY 3,
                   :affectStroke false}
        question-object (poll-v2-sticker/fit-lines-textbox text
                                                           {:fill text-color
                                                            :top 90
                                                            :originX "center"
                                                            :originY "top"
                                                            :width (- question-width 80)
                                                            :fontSize 55
                                                            :fontFamily "Roboto"
                                                            :fontWeight "bold"
                                                            :textAlign "center"}
                                                           3)
        top-offset (.-height question-object)
        panel-object (js/fabric.Rect. #js{:fill background-color
                                          :width question-width
                                          :rx 26
                                          :ry 26
                                          :height (+ min-panel-height
                                                     top-offset)
                                          :originX "center"
                                          :originY "top"
                                          :shadow shadow})
        profile-border (js/fabric.Circle. #js{:fill background-color
                                              :radius 63
                                              :originX "center"
                                              :originY "top"
                                              :top -63
                                              :shadow shadow})
        profile-pic (js/fabric.Circle. #js{:fill (sticker-util/shadow-color background-color)
                                           :radius 55
                                           :originX "center"
                                           :originY "top"
                                           :top -55})

        answer-panel (js/fabric.Rect. #js{:fill (sticker-util/shadow-color background-color)
                                          :width answer-width
                                          :height answer-height
                                          :rx 20
                                          :originX "center"
                                          :originY "center"
                                          :bottom 20})
        answer-text (js/fabric.Textbox. "Type something ..."
                                        #js{:fill (sticker-util/darken text-color 20)
                                            :originX "center"
                                            :originY "center"
                                            :width answer-width
                                            :fontSize 35
                                            :fontFamily "Roboto"
                                            :textAlign "center"})
        answer-group (js/fabric.Group. (into-array [answer-panel answer-text])
                                       #js{:originY "bottom"
                                           :top (+ min-panel-height
                                                   top-offset
                                                   -46)})]

    (js/fabric.Group. (into-array [profile-border panel-object profile-pic question-object answer-group])
                      #js{:id "question-sticker"
                          :lockScalingFlip true
                          :max-scale 1.3
                          :min-scale 0.3
                          :question #js{:question text
                                        :background_color background-color
                                        :text_color text-color}
                          :top (or (:top params) 10)
                          :left (or (:left params) 10)
                          :angle (or (:angle params) 0.0)
                          :scaleY (or (:scaleX params) 1.0)
                          :scaleX (or (:scaleY params) 1.0)})))
